module.exports = __webpack_public_path__ + "img/35.aaf86941.png";